/**
 * Frontend client for the Docs/assets API (server/modules/assets) — real Docs
 * storage behind the Drive Docs chip + Upload. Workspace-scoped via the shared
 * client (auth token + active-workspace header).
 */
import { apiGet, apiPost, apiDelete } from "../shared/apiClient";

/** Mirrors the upload route's zod enum (server/modules/assets/asset.validation.ts).
 *  `hdr` / `exr`: HDR Studio's Vault saves (the baked map and imported textures). */
export type AssetKind = "doc" | "image" | "render" | "glb" | "vjson" | "hdr" | "exr";

export interface VaultAsset {
  _id: string;
  workspaceId: string;
  folderId: string | null;
  kind: AssetKind;
  name: string;
  s3Key: string;
  url: string;
  size: number;
  mime: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export interface UploadAssetInput {
  name: string;
  folderId?: string;
  kind: AssetKind;
  dataUrl: string;
}

export const listAssets = (params: { folderId?: string; kind?: AssetKind } = {}) => {
  const qs = new URLSearchParams();
  if (params.folderId) qs.set("folderId", params.folderId);
  if (params.kind) qs.set("kind", params.kind);
  const q = qs.toString();
  return apiGet<VaultAsset[]>(`/assets${q ? `?${q}` : ""}`);
};

export const uploadAsset = (input: UploadAssetInput) =>
  apiPost<VaultAsset>("/assets", input);

export const deleteAsset = (id: string) =>
  apiDelete<{ id: string }>(`/assets/${id}`);
